import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';

interface Props {
    numOfIterations: number;
    riskIds: number[];
    taskVersionHashCode: string | null;
    taskVersionLabel: string | null;
    isRunningQsra: boolean;
    showModal: boolean;
    period: 'DAY' | 'WEEK';
    activeTab: 'chart' | 'table';
    runQsra: number | null;
    qsraResponseKey: string | null;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    numOfIterations: 10,
    riskIds: [],
    taskVersionHashCode: null,
    taskVersionLabel: null,
    isRunningQsra: false,
    showModal: false,
    period: 'WEEK',
    activeTab: 'table',
    runQsra: null,
    qsraResponseKey: null,
    update: (value) => set({ ...value }),
});

export const useRiskRegisterStore = create(state);
